import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { IoIosArrowBack } from 'react-icons/io';
import Footer from '../../src/components/Footer';
import { requestUserRegisters, requestNewUnits } from '../services/requests';
import { FaCheckCircle } from 'react-icons/fa';
import { registerSchema } from '../Schemas/registerSchema';
import NavBar from '../components/NavBar';


function Register() {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [password2, setPassword2] = useState('');
	const [cpf, setCpf] = useState('');
	const [newLoginCreated, setNewLoginCreated] = useState(false);
	const [cardAnimation, setCardAnimation] = useState(false);
	const [units, setUnits] = useState([]);
	const [showAlert, setShowAlert] = useState(false);
	const [errorMessage, setErrorMessage] = useState([]);
	const [showPassword, setShowPassword] = useState(false);
	const [showPassword2, setShowPassword2] = useState(false);
	const [password2Alert, setpassword2Alert] = useState(false);
	const [isDisabled, setIsDisabled] = useState(true);
	const [unitList, setUnitList] = useState([]);
	const [inputValue, setInputValue] = useState('');
	const [unitSelected, setUnitSelected] = useState(false);
	const [showUnit, setShowUnit] = useState(false);
	const [filteredList, setFilteredList] = useState([]);
	const navigate = useNavigate();


	const requestUnits  = async () => {
		const response = await requestNewUnits();
		if (response.error) {
			console.log(response.error);
		} else {
			let result = []
			response.forEach((item) => {
				result.push({nome: item.nome, cnes: item.cnes, id: item.id})
			})
			setUnits( result);
		}
	}

	useEffect(() => {
		requestUnits();
		const enabledButton = () => {
			const { error } = registerSchema.validate({
				cpf,
				email,
				password,
			});
			if (password.length !== 0 || password2.length !== 0) {
				setpassword2Alert(password === password2);
			}
			if (!error) {
				if (password === password2) {
					setIsDisabled(false);
				} else {
					setIsDisabled(true);
				}
			} else {
				setIsDisabled(true);
			}
		};

		enabledButton();
	}, [cpf, email, password, password2]);

	const populateStorage = (value, id) => {
		if (id === 'email') {
			localStorage.setItem([id], value);
			setEmail(value);
		} else if (id === 'password') {
			setPassword(value);
		} else if (id === 'password2') {
			setPassword2(value);
		} else if (id === 'cpf') {
			localStorage.setItem([id], value);
			setCpf(value);
		}
	};

	const handleRegister = async () => {
		const data = await requestUserRegisters({
			username: cpf,
			email,
			password,
			password_confirmation: password2,
			unidade_ids: unitList.includes('Subhue')
				? []
				: unitList
						.map((item) =>
							units.filter((unit) => unit.nome === item)
						)
						.map((item) => item[0]?.id),
		});
		console.log(data)
		if (Object.keys(data).includes('error')) {
			 	console.log({
				username: cpf,
				email,
				password,
				unidade_ids: unitList.includes('Subhue')
				? []
				: unitList
						.map((item) =>
							units.filter((unit) => unit.nome === item)
						)
						.map((item) => item[0]?.id),
			}); 
			setShowAlert(true);
			setErrorMessage(data.error);
		} else {
			console.log(data)
			setNewLoginCreated(true);
			setTimeout(() => {
				setCardAnimation(true);
			}, 100);
			return data;
		}
	};
	const handleInputChange = (e) => {
		const query = e.target.value;
		setInputValue(query);

		if (query.length === 0) {
			setUnitSelected(false);
		}
		if (query) {
			const filtered = [...units, { nome: 'Subhue' }]
				.map((item) => item.nome)
				.filter((option) =>
					option.toLowerCase().includes(query.toLowerCase())
				);
			setFilteredList(filtered);
		} else {
			setFilteredList([]);
		}
	};
	const removeUnit = (item) => {
		const List = unitList.filter((unit) => unit !== item);
		setUnitList(List);
	};
	const handleSelectItem = (item) => {
		let List = unitList;
		if (!List.includes(item)) {
			List.push(item);
			setUnitList(List);
		}
		setInputValue(item);
		setFilteredList([]);
	};

	return (
		<div className='flex flex-col min-h-screen font-inter'>
			<NavBar />

			<div className='text-center flex-grow mt-32 my-10 md:mt-20 md:my-10'>
				{newLoginCreated && (
					<div className='fixed flex w-full h-full z-10 opacity-60 bg-black'></div>
				)}
				{newLoginCreated && (
					<div
						className={`fixed rounded-[8px] top-2/4 left-1/2 -translate-x-1/2 -translate-y-3/4 z-20 transition-all p-3 duration-500 bg-white flex flex-col items-center  overflow-hidden ${
							cardAnimation
								? 'w-[60%] lg:w-[36%] xl:w-[25%] 2xl:w-[22%] h-[150px] opacity-100 scale-100'
								: 'w-0 h-0 opacity-0 scale-0'
						}`}>
						<div
							className={`flex items-center h-full justify-center transition-all duration-500 gap-6 p-6 overflow-hidden 
															w-full`}>
							<div className='text-[#32993E] content-center transition-all duration-500'>
								<FaCheckCircle className='scale-[180%] transition-all duration-500' />
							</div>
							<p className='text-[#757575] font-inter content-center text-[24px] text-center font-normal transition-all duration-500'>
								Login cadastrado
							</p>
						</div>
						<button
							className='text-sm font-medium border-[1.2px] p-2 px-10 rounded-md border-[#c7c7c7] hover:bg-[#c2c2c2]  text-[#757575] hover:text-[white] transition-all duration-200 mb-2'
							onClick={() => {
								navigate('/login');
							}}>
							{' '}
							Fazer Login
						</button>
					</div>
				)}

				{/* <div className='absolute left-2'>
					<button
						type='button'
						onClick={() => navigate('/login')}
						className='text-white w-[2rem] enabled:hover:bg-[#004A80] bg-blue-300 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-sm mt-5 p-2 '>
						<IoIosArrowBack className='scale-150  ' />
					</button>
				</div> */}
				<section>
					<div className='flex flex-col items-center mt-[2%] mx-auto md:h-full lg:py-0'>
						<div className='w-[88%] md:w-full bg-white rounded-lg shadow border md:mt-0 sm:max-w-lg xl:p-0'>
							<div className='p-6 pb-2 space-y-4 md:space-y-6 sm:p-8'>
								<h1 className='text-xl font-bold leading-tight tracking-tight text-[#004A80] md:text-3xl'>
									Criar novo login
								</h1>
								<form
									className='space-y-4 md:space-y-6'
									action='#'>
									<div>
										<input
											value={cpf}
											onChange={({
												target: { value },
												target: { id },
											}) => populateStorage(value, id)}
											type='number'
											name='cpf'
											id='cpf'
											className='border border-[#E3E3E3] text-[#757575] sm:text-sm rounded-md  focus:ring-primary-600 placeholder:text-[#E3E3E3] focus:border-primary-600 block w-full p-2.5'
											placeholder='CPF'
											required=''
										/>
										<p
											htmlFor='remember'
											className='text-[#979797] ml-1 text-start text-[10px]'>
											Somente numeros
										</p>
									</div>
									<div>
										<input
											value={email}
											onChange={({
												target: { value },
												target: { id },
											}) => populateStorage(value, id)}
											type='email'
											step='1'
											name='email'
											id='email'
											className='border border-[#E3E3E3] text-[#757575] sm:text-sm rounded-md focus:ring-primary-600 placeholder:text-[#E3E3E3] focus:border-primary-600 block w-full p-2.5'
											placeholder='E-mail'
											required=''
										/>

										{/* 	{showAlert ? (
											<p
												htmlFor='remember'
												className='text-red-600 text-start text-[10px]'>
												{errorMessage[0]}
											</p>
										) : (
											''
										)} */}
									</div>
									<div className='relative'>
										{/* <button
														type='button'
														className=''>
														botão
													</button> */}
										<input
											type='text'
											value={inputValue}
											onChange={handleInputChange}
											onClick={() => {
												setShowUnit(true);
												setFilteredList(
													[
														...units,
														{ nome: 'Subhue' },
													].map((item) => item.nome)
												);
												setInputValue('');
											}}
											placeholder='Unidade'
											className='border border-[#E3E3E3] text-[#757575] sm:text-sm rounded-md focus:ring-primary-600 placeholder:text-[#E3E3E3] focus:border-primary-600 block w-full p-2.5'
										/>
										{/* <p
											htmlFor='remember'
											className='text-[#808080] text-start text-[10px]'>
											Escolha a(s) unidade(s) em que esta
											lotado
										</p> */}

										<div
											onClick={(e) =>
												removeUnit(e.target.id)
											}
											className={`flex gap-2  mb-0 max-w-[300px] rounded-sm flex-wrap ${
												unitList.length > 0
													? 'mt-1 p-1'
													: 'mt-0 p-0'
											}`}>
											{unitList?.map((item, index) => (
												<button
													key={index}
													id={item}
													onClick={(e) =>
														removeUnit(e.target.id)
													}
													className='flex items-center text-[10px] bg-[#dbdbdb] hover:bg-[#636363] hover:text-[#d1d1d1] rounded-sm p-1 font-medium text-[#585858] gap-1 transition-all duration-200'>
													{item}
													{/* <div
														onClick={(e) =>
															removeUnit(
																e.target.id
															)
														}
														className='text-[12px] font-bold leading-none self-start'>
														x
													</div> */}
												</button>
											))}
										</div>

										{filteredList.length > 0 && (
											<ul className='mt-2 border absolute border-gray-300 rounded transition-all z-40  shadow-lg top-10 overflow-y-scroll max-h-[300px]'>
												{filteredList.map(
													(item, index) => (
														<li
															key={index}
															onClick={() => {
																setUnitSelected(
																	true
																);
																handleSelectItem(
																	item
																);
															}}
															className='p-2 w-[363px] bg-gray-100 cursor-pointer  hover:bg-gray-200'>
															{item}
														</li>
													)
												)}
											</ul>
										)}
									</div>
									<div>
										<div className='relative'>
											<input
												value={password}
												onChange={({
													target: { value },
													target: { id },
												}) => setPassword(value, id)}
												type={
													showPassword
														? 'text'
														: 'password'
												}
												name='password'
												id='password'
												placeholder='Senha'
												autoComplete='true'
												className='border border-[#E3E3E3] text-[#757575] sm:text-sm rounded-md focus:ring-primary-600 placeholder:text-[#E3E3E3] focus:border-primary-600 block w-full p-2.5'
												required=''
											/>
											<button
												type='button'
												onClick={() =>
													setShowPassword(
														!showPassword
													)
												}
												className='absolute bottom-[12px] right-[12px] text-gray-500'>
												{!showPassword ? (
													<FaEyeSlash />
												) : (
													<FaEye />
												)}
											</button>
										</div>
										<p
											htmlFor='remember'
											className='text-[#a0a0a0] ml-1 text-start text-[10px]'>
											Digite Sua Senha (Mínimo 8
											Caracteres)
										</p>
									</div>
									<div className=''>
										<div className='relative'>
											<input
												value={password2}
												onChange={({
													target: { value },
													target: { id },
												}) => setPassword2(value, id)}
												type={
													showPassword2
														? 'text'
														: 'password'
												}
												name='password2'
												id='password2'
												placeholder='Digite a Senha Novamente'
												autoComplete='true'
												className='border border-[#E3E3E3] text-[#757575] sm:text-sm rounded-md focus:ring-primary-600 placeholder:text-[#E3E3E3] focus:border-primary-600 block w-full p-2.5'
												required=''
											/>
											<button
												type='button'
												onClick={() =>
													setShowPassword2(
														!showPassword2
													)
												}
												className=' absolute bottom-[12px] right-[12px] text-gray-500'>
												{!showPassword2 ? (
													<FaEyeSlash />
												) : (
													<FaEye />
												)}
											</button>
										</div>

										{password2Alert ? (
											''
										) : (
											<p
												htmlFor='remember'
												className='text-red-600 text-start text-[10px]'>
												Senhas não coincidem
											</p>
										)}
									</div>
									{/* {errorMessage[0].includes(
												'O CPF não existe na base de Recursos Humanos.'
											)
												? 'CPF não encontrado, entre em contato com a equipe de suporte'
												: errorMessage[0]
														.split(',')
														.map((s) => s.trim())
														.map((item, index) => (
															<p key={index}>
																{item.slice(
																	1,
																	-1
																)}
															</p>
														))} */}
									{showAlert ? (
										<p
											htmlFor='remember'
											className='text-red-600 text-center text-[10px]'>
											{errorMessage.map(
												(item, index) => item
											)}
										</p>
									) : (
										''
									)}
									<div className='relative'>
										<div className='h-0.5 w-full rounded-lg bg-[#E3E3E3]'></div>
										<button
											type='button'
											onClick={handleRegister}
											disabled={isDisabled}
											className='text-gray-400 enabled:bg-[#004A80] transition-all duration-300 enabled:hover:bg-[#13335A] border-[#E3E3E3] enabled:border-none border-[1px] focus:ring-4 focus:ring-blue-300 enabled:text-white font-normal rounded-md text-[15px] w-[60%] px-5 py-2 me-2 mb-2 mt-7 '>
											Enviar
										</button>
									</div>
									<div className='text-[#004A80] hover:text-[#3f84b4]'>
										<a href='/login'>Já tem login?</a>
									</div>
								</form>
							</div>
						</div>
					</div>
				</section>
			</div>
			<div>
				<Footer />
			</div>
		</div>
	);
}

export default Register;
